<template>
  <div id="app" class="main-view">
    <div class="main-wrapper">
      <ecHeaderBox v-if="$route.path!=='/'" />
      <div class="main-body" style="margin-bottom: 40px;">
        <router-view />
      </div>
      <ecFooterBox v-if="$route.path!=='/'" />
    </div>
  </div>
</template>
<script>
import ecHeaderBox from "./components/ecHeaderBox";
import ecFooterBox from "./components/ecFooterBox";
export default {
  components: {
    ecHeaderBox,
    ecFooterBox,
  },
};
</script>
<style>
</style>
